import { DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutExtraPayCompareItem extends Layout {
    sourceEdiCompareItem: DataSource;
    tableCompareItems: Table;
}
